import React from 'react'
import { ShowWhatYouKnow } from 'cvs-core'
import voAudio from '../../assets/vo/CVS-HS-SPM-Prepare-03-01.mp3'
import image from '../../assets/images/U2-T1-1-3a.svg'

const vo = {
  src: voAudio,
}
const topic = 'living vape free'

export default {
  title: 'Show What You Know',
  path: '/prepare/show-what-you-know',
  content: <ShowWhatYouKnow topic={topic} vo={vo} image={image} />,
}



// WEBPACK FOOTER //
// ./src/data/Prepare/ShowWhatYouKnow.js